<template>
  <v-layout class="patient-page" column>
    

      <v-card flat class="ma-2 mt-4">
        <v-layout row>
          <span class="headerTabUnselected" @click="adminHome()">Admin</span><span class="headerTabSelected">Patients</span>
        </v-layout>

    <v-text-field hide-details solo flat background-color="transparent" class="search-field mt-3 mb-4"
           v-model="search" prepend-icon="search" label='Search by patient or user last name, email address' single-line></v-text-field>
           <v-layout row><v-btn @click="filterSmartChoice()">Smart Choice</v-btn><v-btn @click="filterImagineMD()">ImagineMD</v-btn><v-btn @click="filterGrayhawk()">Grayhawk</v-btn></v-layout>

        <v-layout v-show="!patientSearchResults" class="fade-in one loader"  row justify-center>
          <v-progress-circular 
            :size="70"
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-layout>

        <v-data-table
        v-if="patientSearchResults"
          :headers="headers"
          :items="patientSearchResults"
          sort-icon=""
          class="flat mb-2 table-border"
          :rows-per-page-items="[15, 100,{text: 'All', value:-1}]"
          :search="search"
          color="#eeeeee"
        >
          <template slot="items" slot-scope="props">
            <tr style="cursor:pointer" @click="props.expanded = !props.expanded">
              <td> {{ formatPartnerName(props.item) }}</td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ formatDate(props.item.created) }}</td>
              <td class="text-xs-left">{{ formatPatientName(props.item) }}</td>
              <td class="text-xs-left">{{ formatDate(props.item.birthdate) }}</td>
              <td class="text-xs-left">{{ formatCreatorEmail(props.item) }}</td>
            </tr>
          </template>

          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-toolbar dense flat color="transparent">
            <v-toolbar-title>{{ formatPatientName(props.item) }}</v-toolbar-title>
            
            <v-spacer></v-spacer>
              
            <v-toolbar-title>
                {{formatPartnerName(props.item)}}
            </v-toolbar-title>
        </v-toolbar>
              <v-card-text>
              <v-layout column>
                <v-layout row wrap>
                <v-card flat class="ma-2">
                  <v-layout column>
                  <span>Address</span>
                  <span>{{providerDisplayAddressFromProviderObject(props.item)}}</span>
                  </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Gender</span>
                  <span>{{props.item.gender}}</span>
                </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Phone</span>
                  <span>{{props.item.phone}}</span>
                </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Creator</span>
                  <span>{{formatCreatorName(props.item)}}</span>
                </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Creator Email</span>
                  <span>{{formatCreatorEmail(props.item)}}</span>
                </v-layout>
                </v-card>
                <v-card v-if="props.item.creator" flat class="ma-2">
                <v-layout column>
                  <v-btn @click="doResetPassword(props.item)" depressed>Send Password Reset</v-btn>
                </v-layout>
                </v-card>
                </v-layout>
                <v-card flat style="opacity:0.5" class="ma-2">
                <span>{{ props.item }}</span>
                </v-card>
              </v-layout>
                </v-card-text>
            </v-card>
          </template>

        </v-data-table>
      </v-card>

  

  </v-layout>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';


.table-border {
  border: 1px solid #f5f5f5;
}

.search-field {
  background: #f5f5f5;
  border-radius: 4px;
  padding-left: 18px;
}

.loader {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 70em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.headerTabUnselected:hover {
  opacity: 1;
}

</style>

<script>
import { mapActions, mapState } from 'vuex'
import Titlebar from '@/components/Titlebar'
import HelperMixin from '@/core/mixins/HelperMixin'
import bus from '@/core/helpers/bus'

export default {
  mixins: [HelperMixin],
  components: {
    Titlebar
  },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Partner',
          align: 'left',
          sortable: true,
          value: 'partner.id'
        },
        { text: 'PatientID',
          sortable: true,
          value: 'id',
          align: 'left' },
        {text: 'Chart Created',
          align: 'left',
          sortable: true,
          value: 'created'
        },
        { text: 'Patient Name',
          sortable: true,
          value: 'lastName',
          align: 'left' },
        { text: 'DOB',
          sortable: true,
          value: 'birthdate',
          align: 'left' },
        { text: 'Creator Email',
          sortable: true,
          value: 'creator.email',
          align: 'left' }
      ]
    }
  },
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList'
    ]),
    ...mapActions('auth', ['resetPassword']),
    doResetPassword(item) {
      if (item.creator) {
        if (item.creator.email) {
          this.resetPassword({ email: item.creator.email })
          this.toast('success', 'Password Reset Sent')
        } else {
          this.toast('error', 'Missing Email')
        }
      } else {
        this.toast('error', 'Missing User')
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    filterImagineMD() {
      this.search = '5b73507c4aef2028740f662b'
    },
    filterSmartChoice() {
      this.search = '5a4fa82c8e4b74e028665d04'
    },
    filterGrayhawk() {
      this.search = '5acb94000495d7065c909bc2'
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    formatCreatorEmail(item) {
      if (item.creator) {
        if (item.creator.email) {
          return item.creator.email
        } else {
          return 'No Email'
        }
      } else {
        return 'No Creator'
      }
    },
    formatPartnerName(item) {
      console.log(item)
      if (item.partner) {
        return this.transformPartnerIDToHumanReadableName(item.partner.id)
      } else {
        return 'Consumer'
      }
    },
    formatPatientName(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName
        } else {
          return 'Missing Patient'
        }
      } else {
        return 'Missing patient'
      }
    },
    formatCreatorName(item) {
      if (item.creator) {
        if (item.creator.lastName) {
          if (item.creator.firstName) {
            return item.creator.firstName + ' ' + item.creator.lastName
          } else {
            return 'Missing Patient'
          }
        } else {
          return 'Missing patient'
        }
      }
    },
    formatDate(timestamp) {
      if (timestamp != null) {
        let d = new Date(timestamp * 1000)
        let MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
        return MyDateString
      }
      return ''
    },
    adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      })
    }
  },
  computed: {
    ...mapState('admin', ['requests', 'patient', 'request', 'patientSearchResults', 'userSearchResults'])
  },
  created() {
    this.getPatientList()
    this.getUserList()
  },
  watch: {
    patientSearchResults() {
      console.log(this.patientSearchResults)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/AdminPatientsPage.vue